// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/bg-logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/bg-logo-sm.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageWrapper_page-wrapper__tTTfJ {
  display: flex;
  width: 100%;
  min-height: 100vh;
}

.PageWrapper_content__o4sSZ {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 300px;
}
.PageWrapper_content__o4sSZ > *:not(.PageWrapper_back__vF5u1) {
  width: 100%;
}

.PageWrapper_outlet__2y27z {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% - 68px);
  padding: 10px 112px 80px;
  background-color: #fff;
}

.PageWrapper_auth__YIBr5 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: #000054;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

@media screen and (max-width: 900px) {
  .PageWrapper_content__o4sSZ {
    padding-left: 250px;
  }
  .PageWrapper_outlet__2y27z {
    padding: 12px 40px 20px;
  }
}
@media screen and (max-width: 600px) {
  .PageWrapper_content__o4sSZ {
    width: 100%;
    padding-left: initial;
    padding-bottom: 120px;
  }
  .PageWrapper_outlet__2y27z {
    width: 100%;
    padding: 12px 20px 0;
  }
  .PageWrapper_auth__YIBr5 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: bottom;
    background-size: 100%;
    padding: 10% 20px 20px 20px;
  }
}
@media screen and (min-width: 2048px) {
  .PageWrapper_outlet__2y27z {
    padding: 50px 350px 80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PageWrapper/PageWrapper.module.scss","webpack://./src/styles/sizes.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBCTe;ADajB;AAFE;EACE,WAAA;AAIJ;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;AAGF;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,yBE5BS;EF6BT,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAGF;;AAAA;EACE;IACE,mBCxCgB;ED2ClB;EAAA;IACE,uBAAA;EAEF;AACF;AACA;EACE;IACE,WAAA;IACA,qBAAA;IACA,qBAAA;EACF;EAEA;IACE,WAAA;IACA,oBAAA;EAAF;EAGA;IACE,yDAAA;IACA,2BAAA;IACA,qBAAA;IACA,2BAAA;EADF;AACF;AAIA;EACE;IACE,wBAAA;EAFF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.page-wrapper {\n  display: flex;\n  width: 100%;\n  min-height: 100vh;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding-left: sizes.$nav-menu-width;\n\n  & > *:not(.back) {\n    width: 100%;\n  }\n}\n\n.outlet {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: calc(100% - sizes.$header-height);\n  padding: 10px 112px 80px;\n  background-color: #fff;\n}\n\n.auth {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100vh;\n  background-color: colors.$primary9;\n  background-image: url(../../assets/bg-logo.svg);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n@media screen and (max-width: sizes.$breakpoint-md) {\n  .content {\n    padding-left: sizes.$nav-menu-width-md;\n  }\n\n  .outlet {\n    padding: 12px 40px 20px;\n  }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .content {\n    width: 100%;\n    padding-left: initial;\n    padding-bottom: 120px;\n  }\n\n  .outlet {\n    width: 100%;\n    padding: 12px 20px 0;\n  }\n\n  .auth {\n    background-image: url(../../assets/bg-logo-sm.svg);\n    background-position: bottom;\n    background-size: 100%;\n    padding: 10% 20px 20px 20px;\n  }\n}\n\n@media screen and (min-width: sizes.$breakpoint-extra-lg) {\n  .outlet {\n    padding: 50px 350px 80px;\n  }\n}\n","$breakpoint-sm: 600px;\n$breakpoint-md: 900px;\n$breakpoint-extra-lg: 2048px;\n\n$nav-menu-width: 300px;\n$nav-menu-width-md: 250px;\n\n$nav-menu-mobile-height: 77px;\n$header-height: 68px;\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"page-wrapper": `PageWrapper_page-wrapper__tTTfJ`,
	"content": `PageWrapper_content__o4sSZ`,
	"back": `PageWrapper_back__vF5u1`,
	"outlet": `PageWrapper_outlet__2y27z`,
	"auth": `PageWrapper_auth__YIBr5`
};
export default ___CSS_LOADER_EXPORT___;
